import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      component: () =>import('@/view/commonPage'),
      redirect: '/zzhlmh/home',
      children: [
        // 首页
        {
          path: 'zzhlmh/home',
          name:'home',
          component: () =>
            import('@/view/home')
        },
        //下载中心
        {
          path: 'zzhlmh/downloadCenter',
          name:'downloadCenter',
          component: () =>
            import('@/view/downloadCenter')
        },
         //联系我们
         {
          path: 'zzhlmh/contactUs',
          name:'contactUs',
          component: () =>
            import('@/view/contactUs')
        },
         //远程异地评标
         {
          path: 'zzhlmh/remoteBidEvaluation',
          name:'remoteBidEvaluation',
          component: () =>
            import('@/view/remoteBidEvaluation')
        },
         //关于我们
         {
          path: 'zzhlmh/aboutUs',
          name:'aboutUs',
          component: () =>
            import('@/view/aboutUs')
        },
         //ca互认中心
         {
          path: 'zzhlmh/ca',
          name:'ca',
          component: () =>
            import('@/view/ca')
        },
         //主体认证共享中心
         {
          path: 'zzhlmh/resourceCenter',
          name:'resourceCenter',
          component: () =>
            import('@/view/resourceCenter')
        },
         //典型案例
         {
          path: 'zzhlmh/typicalCase',
          name:'typicalCase',
          component: () =>
            import('@/view/typicalCase')
        },
         //应用中心
         {
          path: 'zzhlmh/applicationCenter',
          name:'applicationCenter',
          component: () =>
            import('@/view/applicationCenter')
        }
       
      ]

    }],
    mode: "history"
  })



// WEBPACK FOOTER //
// ./src/router/index.js